import p1 from './img_0.png'
import p2 from './img_1.png'
import p3 from './img_2.png'

export default {
  v: '5.7.8',
  fr: 24,
  ip: 0,
  op: 144,
  w: 128,
  h: 128,
  nm: 'ic_work_jpg@2x',
  ddd: 0,
  assets: [
    { id: 'image_0', w: 128, h: 128, u: '', p: p1, e: 0 },
    { id: 'image_1', w: 56, h: 56, u: '', p: p2, e: 0 },
    { id: 'image_2', w: 128, h: 128, u: '', p: p3, e: 0 },
  ],
  layers: [
    {
      ddd: 0,
      ind: 1,
      ty: 2,
      nm: 'ic_work_jpg@2x.png',
      cl: 'png',
      refId: 'image_0',
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [100] },
            { t: 48, s: [0] },
          ],
          ix: 11,
        },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            { i: { x: 0.833, y: 0.833 }, o: { x: 0.167, y: 0.167 }, t: 0, s: [64, 70, 0], to: [0, -1, 0], ti: [0, 1, 0] },
            { t: 48, s: [64, 64, 0] },
          ],
          ix: 2,
          l: 2,
        },
        a: { a: 0, k: [64, 64, 0], ix: 1, l: 2 },
        s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
      },
      ao: 0,
      ip: 0,
      op: 48,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 2,
      ty: 2,
      nm: 'ic_work_gf@2x.png',
      cl: 'png',
      refId: 'image_1',
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 48, s: [0] },
            { t: 72, s: [100] },
          ],
          ix: 11,
        },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [52, 42, 0], ix: 2, l: 2 },
        a: { a: 0, k: [28, 28, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            { i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] }, t: 72, s: [100, 100, 100] },
            { i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] }, t: 96, s: [140, 140, 100] },
            { i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] }, t: 108, s: [80, 80, 100] },
            { t: 120, s: [110, 110, 100] },
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      ip: 48,
      op: 144,
      st: 72,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 3,
      ty: 2,
      nm: 'ic_work_bg@2x.png',
      cl: 'png',
      refId: 'image_2',
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 24, s: [0] },
            { t: 47, s: [100] },
          ],
          ix: 11,
        },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            { i: { x: 0.833, y: 0.833 }, o: { x: 0.167, y: 0.167 }, t: 24, s: [64, 70, 0], to: [0, -1, 0], ti: [0, 1, 0] },
            { t: 60, s: [64, 64, 0] },
          ],
          ix: 2,
          l: 2,
        },
        a: { a: 0, k: [64, 64, 0], ix: 1, l: 2 },
        s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
      },
      ao: 0,
      ip: 24,
      op: 144,
      st: 48,
      bm: 0,
    },
  ],
  markers: [],
}
